// Matriz mensual de km y horas (GET /reports/quick/monthly). Lo puro vive aquí
// para probarlo sin montar la página.
import api from "../../../utils/api";

export interface MatrixRow {
  device_id: string;
  vehicle_id: string | null;
  unit_name: string;
  plate: string | null;
  km: Record<string, number>;
  driving_h: Record<string, number>;
  total_km: number;
  total_driving_h: number;
  active_days: number;
}

export interface MonthlyMatrix {
  tz: string;
  month: string;
  days: string[];
  rows: MatrixRow[];
  totals_km_by_day: Record<string, number>;
}

export type Metric = "km" | "hours";

export async function fetchMonthlyMatrix(companyId: string, month: string): Promise<MonthlyMatrix> {
  const { data } = await api.get("/reports/quick/monthly", { params: { companyId, month }, headers: { "x-company-id": companyId } });
  return (data?.rows ? data : data?.data) as MonthlyMatrix;
}

export const valueOf = (r: MatrixRow, day: string, metric: Metric): number | undefined => (metric === "km" ? r.km[day] : r.driving_h[day]);
export const totalOf = (r: MatrixRow, metric: Metric) => (metric === "km" ? r.total_km : r.total_driving_h);

/** Intensidad 0-1 para el mapa de calor (relativa al máximo del mes). */
export const heat = (v: number | undefined, max: number): number => (v && max > 0 ? Math.min(1, v / max) : 0);

export const fmtValue = (v: number | undefined, metric: Metric): string => {
  if (v == null) return "";
  if (metric === "km") return v === 0 ? "0" : v < 10 ? v.toFixed(1) : String(Math.round(v));
  const min = Math.round(v * 60);
  return min === 0 ? "0" : `${Math.floor(min / 60)}:${String(min % 60).padStart(2, "0")}`;
};

/** Filas para Excel/PDF: una columna por día más el total. */
export const exportRows = (m: MonthlyMatrix, metric: Metric) =>
  m.rows.map((r) => ({
    id: r.device_id,
    unidad: r.plate ? `${r.unit_name} (${r.plate})` : r.unit_name,
    ...Object.fromEntries(m.days.map((d) => [d, fmtValue(valueOf(r, d, metric), metric)])),
    total: fmtValue(totalOf(r, metric), metric),
  }));
